<template>
  <v-tooltip content-class="tooltip" right>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <!-- drop機能ありのサムネイル -->
        <AppFileDropArea
          :class="dropAreaStyles"
          v-if="droppable"
          :loading="fileUploadAreaLoading"
          @files="onDrop"
        >
          <AppFixedImage
            :src-url="imageUrl"
            :width="wrapperSize.width"
            :height="wrapperSize.height"
            :image-width="boundingWidth"
            :image-height="boundingHeight"
            :class="[imageStyles]"
          />
          <template v-slot:drag>
            <AppFixedImage
              :src-url="banner.image.src"
              :width="wrapperSize.width"
              :height="wrapperSize.height"
              :image-width="boundingWidth"
              :image-height="boundingHeight"
              :class="[imageStyles, dragInStyles]"
            />
          </template>
          <div :class="iconStyles">
            <v-icon>photo_library</v-icon>
          </div>
        </AppFileDropArea>

        <!-- drop機能なしのサムネイル -->
        <AppFixedImage
          v-else
          :src-url="imageUrl"
          :width="wrapperSize.width"
          :height="wrapperSize.height"
          :image-width="boundingWidth"
          :image-height="boundingHeight"
          :class="[imageStyles]"
        />
      </div>
    </template>
    <img :src="imageUrl" :style="tooltipImageStyle" />
  </v-tooltip>
</template>

<script>
import { css } from 'emotion'

const maxWidth = 200
const maxHeight = 120

export default {
  name: 'BannerThumbnail',
  props: {
    banner: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    maxWidth: {
      type: Number,
      default: maxWidth,
    },
    maxHeight: {
      type: Number,
      default: maxHeight,
    },
    droppable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      fileUploadAreaLoading: false,
    }
  },
  computed: {
    imageUrl() {
      return (
        (this.banner.image && this.banner.image.src) || this.banner.imageUrl
      )
    },
    aspectRatio() {
      return this.height / this.width
    },
    fixedAspectRatio() {
      return this.maxHeight / this.maxWidth
    },
    isWider() {
      return this.aspectRatio <= this.fixedAspectRatio
    },
    boundingWidth() {
      return this.isWider ? this.maxWidth : this.maxHeight / this.aspectRatio
    },
    boundingHeight() {
      return this.isWider ? this.maxWidth * this.aspectRatio : this.maxHeight
    },
    wrapperSize() {
      return {
        width: this.maxWidth,
        height: this.maxHeight,
      }
    },
    imageStyles() {
      return css`
        position: relative;

        &::after {
          content: '';
          display: flex;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }
      `
    },
    tooltipImageStyle() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
      }
    },
    dragInStyles() {
      return css`
        position: relative;

        &::after {
          content: 'ここにドロップできます。' !important;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          color: white;
          font-size: 14px;
        }
      `
    },
    dropAreaStyles() {
      return css`
        position: relative;

        &:hover {
          opacity: 0.75;
        }
      `
    },
    iconStyles() {
      return css`
        position: absolute;
        right: 0;
        bottom: 0;
      `
    },
  },
  methods: {
    async onDrop(files) {
      const [file] = files
      this.fileUploadAreaLoading = true
      try {
        await this.banner.changeImage(file)
      } catch (e) {
        this.$confirm('クリエイティブが正常に変更されませんでした。', {
          body: e.message,
          onlyOk: true,
        })
      } finally {
        this.fileUploadAreaLoading = false
        if (this.banner.isCheckOverCompressionRate) {
          const result = await this.$confirm('自動圧縮後の画像チェック', {
            imageUrl: this.banner.image.src,
            body: `画像サイズが大きいため、圧縮により画質が低下している場合があります。
                この画像を利用して入稿しますか？
                ※ 画質に問題がある場合、画像を圧縮し再度アップロードしてください。`,
          })
          result
            ? this.$emit('checkedOverCompression')
            : this.$emit('deleteBanner')
        }
      }
    },
  },
}
</script>

<style>
.tooltip {
  opacity: 1 !important;
}
</style>
